import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AlertifyService } from './alertify.service';
import { CustomerPayVM, OperationResult } from '../models/ViewModels';
import { environment } from '../../environments/environment';
import { ErrorService } from '../interceptors/error.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerPayService {

  paymentApi = `${environment.apiUrl}/PaymentFromCustomer`;

  constructor(private http: HttpClient,
    private errorService: ErrorService,
    private alertify: AlertifyService) { }

  create(pay: CustomerPayVM) {
    return this.http.post(this.paymentApi, pay).pipe(
      map((response: OperationResult<CustomerPayVM>) => {
        if (response.Success) {
          this.alertify.success("Registro creado exitosamente.");
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  update(pay: CustomerPayVM) {
    return this.http.put(this.paymentApi, pay).pipe(
      map((response: OperationResult<CustomerPayVM>) => {
        if (response.Success) {
          this.alertify.success("Registro editado exitosamente.");
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  deletePay(pay: CustomerPayVM) {
    const uri = `${this.paymentApi}/DeletePayment`;
    return this.http.put(uri, pay).pipe(
      map((response: OperationResult<boolean>) => {
        if (response.Success) {
          this.alertify.success("Registro eliminado exitosamente.");
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return false;
        }
      }));
  }

  delete(id: string) {
    const uri = `${this.paymentApi}?uuid=${id}`;
    return this.http.delete(uri).pipe(
      map((response: OperationResult<boolean>) => {
        if (response.Success) {
          this.alertify.success("Registro eliminado exitosamente");
          return true;
        } else {
          this.errorService.logerrorMessage(response);
          return false;
        }
      }));
  }

  getAll() {
    return this.http.get(this.paymentApi).pipe(
      map((response: OperationResult<CustomerPayVM[]>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  getById(id: string) {
    const uri = `${this.paymentApi}/GetByIdentifier?uuid=${id}`;
    return this.http.get(uri).pipe(
      map((response: OperationResult<CustomerPayVM>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }
}
